import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import App from './components/App/App';

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLInputElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
  );
  